import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => {
	const title = 'JaseOwns - Gaming - EverQuest Legends'
	const description =
		"EverQuest Legends is Daybreak's new take on EverQuest. I've been streaming it — including Dungeon Runs, where a brand new character runs to a dungeon with no help."
	return [
		{ title: title },
		{ description: description },
		{
			name: 'keywords',
			content: 'everquest legends,everquest,daybreak,mmo,streams,dungeon runs',
		},
		{ property: 'twitter:card', content: 'summary' },
		{ property: 'twitter:creator', content: '@jaseowns' },
		{ property: 'twitter:site', content: '@jaseowns' },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
	]
}

export default function Index() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">
					<Link to="/gaming" className="underline">Gaming</Link> - EverQuest Legends
				</h1>
				<div className="px-10">
					<div className="my-6 space-y-4">
						<p>
							EverQuest Legends is Daybreak's new take on EverQuest, and it has
							pulled me right back into Norrath. I played the original{' '}
							<Link to="/gaming/everquest" className="underline">EverQuest</Link>{' '}
							back in the day, so getting to experience a fresh version of this
							world — and stream it — has been a blast.
						</p>
						<p>
							I've been streaming EverQuest Legends on YouTube and Twitch.
							Check the <Link to="/schedule" className="underline">schedule</Link>{' '}
							to catch one live, or browse{' '}
							<Link to="/videos" className="underline">past videos</Link>.
						</p>
					</div>

					<h2 className="text-3xl my-6 text-cyan-900 dark:text-cyan-200">
						Dungeon Runs
					</h2>
					<div className="my-6 space-y-4">
						<p>
							My current EverQuest Legends project: <strong>Dungeon Runs</strong>.
							The rules are simple — make a brand new character, and run it from
							the starting city all the way to a dungeon. No ports, no twinking,
							no help. Just a naked newbie, a long road, and everything that
							wants to eat me along the way. Every run is streamed live and
							recorded.
						</p>
						<p className="text-center italic font-bold">
							Planning your own run? Use the{' '}
							<Link to="/gaming/everquest-legends/dungeon-runs" className="underline">
								Dungeon Run route planner
							</Link>{' '}
							— pick a race and see the zone-by-zone path to every dungeon.
						</p>
					</div>

					<h2 className="text-3xl my-6 text-cyan-900 dark:text-cyan-200">
						Join in
					</h2>
					<div className="my-6 space-y-4">
						<p>
							Playing EverQuest Legends yourself? Come hang out in the{' '}
							<Link to="/discord" className="underline">Discord</Link> and tell
							me which dungeon I should run to next.
						</p>
					</div>
				</div>
			</section>

			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}
